import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgCourtSearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.917 53.948h35.338v8.835H14.977a2.06 2.06 0 0 1-2.06-2.06v-6.775Z"
        fill="#599F40"
      />
      <path
        d="M39.42 53.948h44.172v6.774a2.06 2.06 0 0 1-2.06 2.06H41.481a2.06 2.06 0 0 1-2.06-2.06v-6.774Z"
        fill="#78B441"
      />
      <path d="M80.5 53.949h-4.417L59.298 37.163l2.209-2.209L80.5 53.95Z" fill="#599F40" />
      <path d="M76.083 53.949h-33.57l16.785-16.786L76.083 53.95Z" fill="#CAE8DF" />
      <path
        d="M34.61 29.25c-.586 0-1.147.233-1.562.647L10.962 51.983a2.209 2.209 0 0 0 1.562 3.77h26.503v-.647l22.086-22.273V29.25H34.61Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.945 30.3a2.209 2.209 0 0 1 3.123 0l22.086 22.087a2.21 2.21 0 0 1-3.123 3.123L61.506 34.986 40.983 55.51a2.208 2.208 0 1 1-3.123-3.123L59.945 30.3Z"
        fill="#78B441"
      />
      <path d="M79.175 62.783H39.42V82.66h39.755V62.783Z" fill="#CAE8DF" />
      <path d="M39.42 62.783H17.334V82.66H39.42V62.783Z" fill="#A6DBCB" />
      <path d="M39.42 57.566a.8.8 0 1 1 0 1.6H12.917a.8.8 0 1 1 0-1.6H39.42Z" fill="#0F172A" />
      <path d="M83.592 57.566a.8.8 0 1 1 0 1.6H39.42a.8.8 0 1 1 0-1.6h44.172Z" fill="#0F172A" />
      <path
        d="M77.774 66.01a4.405 4.405 0 0 0 1.401-3.227h-8.834c0 1.273.539 2.421 1.402 3.227a4.405 4.405 0 0 0-1.402 3.228V82.66h8.834V69.238c0-1.273-.539-2.421-1.401-3.228Z"
        fill="#78B441"
      />
      <path
        d="M79.175 69.227v6.807a8.836 8.836 0 0 1-8.754-7.638 4.41 4.41 0 0 1 1.322-2.386 4.405 4.405 0 0 1-1.402-3.227h8.834a4.432 4.432 0 0 1-1.401 3.227 4.405 4.405 0 0 1 1.401 3.216Z"
        fill="#599F40"
      />
      <path
        d="M64.522 66.01a4.405 4.405 0 0 0 1.401-3.227H57.09c0 1.273.54 2.421 1.402 3.227a4.405 4.405 0 0 0-1.402 3.228V82.66h8.835V69.238c0-1.273-.54-2.421-1.402-3.228Z"
        fill="#78B441"
      />
      <path
        d="M65.924 69.227v6.807a8.836 8.836 0 0 1-8.755-7.638 4.41 4.41 0 0 1 1.322-2.386 4.405 4.405 0 0 1-1.402-3.227h8.835a4.431 4.431 0 0 1-1.402 3.227 4.405 4.405 0 0 1 1.401 3.216Z"
        fill="#599F40"
      />
      <path
        d="M51.27 66.01a4.405 4.405 0 0 0 1.402-3.227h-8.835c0 1.273.54 2.421 1.402 3.227a4.405 4.405 0 0 0-1.402 3.228V82.66h8.835V69.238c0-1.273-.54-2.421-1.402-3.228Z"
        fill="#78B441"
      />
      <path
        d="M52.672 69.227v6.807a8.836 8.836 0 0 1-8.754-7.638 4.41 4.41 0 0 1 1.321-2.386 4.405 4.405 0 0 1-1.402-3.227h8.835a4.431 4.431 0 0 1-1.402 3.227 4.405 4.405 0 0 1 1.402 3.216Z"
        fill="#599F40"
      />
      <path d="M79.175 61.983a.8.8 0 1 1 0 1.6h-61.84a.8.8 0 1 1 0-1.6h61.84Z" fill="#0F172A" />
      <path
        d="M38.62 81.335V64.108a.8.8 0 0 1 1.6 0v17.227a.8.8 0 0 1-1.6 0Zm37.463-28.187a.801.801 0 0 1 0 1.6h-33.57a.8.8 0 0 1 0-1.6h33.57Zm-17.587-22.53a.8.8 0 1 1 1.13 1.132L39.308 52.069a.8.8 0 0 1-1.13-1.13l20.319-20.32Z"
        fill="#fff"
      />
      <path
        d="M9 93a2 2 0 0 1 2-2h27a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2v-5Z"
        fill="#80CCB5"
      />
      <path
        d="M35 93a2 2 0 0 1 2-2h49a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H37a2 2 0 0 1-2-2v-5Z"
        fill="#A6DBCB"
      />
      <path d="M13 84a2 2 0 0 1 2-2h27a2 2 0 0 1 2 2v7H13v-7Z" fill="#80CCB5" />
      <path d="M40 84a2 2 0 0 1 2-2h40a2 2 0 0 1 2 2v7H40v-7Z" fill="#A6DBCB" />
      <path
        d="M79 81.2a.8.8 0 1 1 0 1.6H17a.8.8 0 1 1 0-1.6h62ZM84 90.2a.8.8 0 1 1 0 1.6H13a.8.8 0 1 1 0-1.6h71Z"
        fill="#0F172A"
      />
      <path
        d="M100.15 68.25a6.857 6.857 0 0 0 6.858-6.857H72.722a6.857 6.857 0 0 1-6.857 6.857h34.285Z"
        fill="#E2E8F0"
      />
      <path
        d="M65.865 68.25a6.857 6.857 0 0 1-6.857-6.857V20.25h34.285v41.143a6.857 6.857 0 0 0 6.857 6.857H65.865Z"
        fill="#F1F5F9"
      />
      <path
        d="M92.493 61.393a7.657 7.657 0 0 0 7.658 7.657.8.8 0 0 0 0-1.6 6.058 6.058 0 0 1-6.058-6.057.8.8 0 0 0-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M68.337 30.694a1.525 1.525 0 0 0-2.073.554l-2.409 4.145-.071.139a1.51 1.51 0 0 0 .627 1.93c.725.416 1.654.17 2.074-.553l1.095-1.883 1.094 1.882c.42.724 1.348.97 2.073.554a1.51 1.51 0 0 0 .556-2.069l-2.409-4.145a1.514 1.514 0 0 0-.557-.554Zm2.101 5.201a.51.51 0 0 1-.19.7.523.523 0 0 1-.71-.19l-1.38-2.374.599-1.03 1.681 2.894Zm-3.437-1.864-1.381 2.375a.523.523 0 0 1-.711.188.51.51 0 0 1-.233-.604l.043-.095 1.683-2.894.599 1.03Zm.317-2.468a.524.524 0 0 1 .522 0 .512.512 0 0 1 .19.698l-.451.774-.45-.774-.032-.062a.507.507 0 0 1 .002-.389l.03-.06a.51.51 0 0 1 .19-.187Z"
        fill="#78B441"
      />
      <path
        d="M64.15 55.179a.5.5 0 1 0 0 1h24a.5.5 0 0 0 0-1h-24Zm0-3.429a.5.5 0 1 0 0 1h24a.5.5 0 0 0 0-1h-24Zm0-3.429a.5.5 0 0 0 0 1h24a.5.5 0 0 0 0-1h-24Zm0-3.428a.5.5 0 0 0 0 1h24a.5.5 0 0 0 0-1h-24Zm0-3.43a.5.5 0 0 0 0 1h24a.5.5 0 0 0 0-1h-24Zm10.286-3.427a.5.5 0 0 0 0 1H88.15a.5.5 0 0 0 0-1H74.436Zm0-3.429a.5.5 0 0 0 0 1H88.15a.5.5 0 0 0 0-1H74.436Zm0-3.428a.5.5 0 0 0 0 1H88.15a.5.5 0 0 0 0-1H74.436Zm0-3.429a.5.5 0 0 0 0 1H88.15a.5.5 0 0 0 0-1H74.436Z"
        fill="#B3C0D0"
      />
      <path
        d="m99.426 40.065 11.109 9.263a2.45 2.45 0 1 1-3.283 3.633L96.918 42.84l2.508-2.775Z"
        fill="#007A5F"
      />
      <path d="m102.917 42.977.33 6.062-6.33-6.2 2.509-2.774 3.491 2.912Z" fill="#00664F" />
      <path
        d="m102.918 42.976.329 6.063-6.33-6.2 2.509-2.774 3.492 2.911Zm-4.615-.178 3.805 3.725-.166-3.057-2.419-2.018-1.22 1.35Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.562 45.818c5.014 2.568 11.16.584 13.728-4.43 2.568-5.015.584-11.162-4.43-13.73-5.016-2.567-11.162-.583-13.73 4.432-2.567 5.015-.583 11.16 4.432 13.728Z"
        fill="#78B441"
      />
      <path
        d="M100.689 36.907a7.31 7.31 0 1 1-14.621-.001 7.31 7.31 0 0 1 14.621 0Z"
        fill="#CAE8DF"
      />
      <path
        d="M87.268 36.906a6.11 6.11 0 0 1 6.11-6.11.5.5 0 1 1 0 1 5.11 5.11 0 0 0-5.11 5.11.5.5 0 1 1-1 0Z"
        fill="#fff"
      />
    </svg>
  )
}
export default wrapIllustration(SvgCourtSearch)
